module.exports = __webpack_public_path__ + "img/banner4@1x.a5f6dec8.png";